import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 引入全局样式
import './styles/index.less';

// 关闭生产提示
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
// 监听页面加载完成后滚动到顶部
window.addEventListener('DOMContentLoaded', () => {
  window.scrollTo(0, 0);
});
 
// 监听hash变化（路由跳转）后滚动到顶部
window.addEventListener('hashchange', () => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
});